module.exports = __webpack_public_path__ + "media/styles/images/svg/arrow-up-white-95326b00ae0fe85a88c6c64a0f2c3bb3.svg";